import * as React from 'react';

import MuiLink from '@material-ui/core/Link';
import { createStyles, WithStyles, withStyles } from '@material-ui/core/styles';
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router-dom';

const styles = () =>
  createStyles({
    link: {
      textDecoration: 'none',
    },
  });

type Props = RouterLinkProps & WithStyles<typeof styles> & { fdKey: string };
const UnderlinedTextButton: React.FC<Props> = (props) => {
  const { to, fdKey, children, classes } = props;

  return (
    <MuiLink
      className={classes.link}
      data-fd={fdKey}
      component={RouterLink}
      to={to}
      variant="subtitle2"
    >
      {children}
    </MuiLink>
  );
};
export default withStyles(styles)(UnderlinedTextButton);
